
import React from 'react';

interface Step {
  number: number;
  label: string;
}

interface OnboardingStepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

const OnboardingStepIndicator: React.FC<OnboardingStepIndicatorProps> = ({ 
  steps, 
  currentStep 
}) => {
  return (
    <div className="hidden sm:block">
      <nav aria-label="Progress">
        <ol className="flex items-center">
          {steps.map((step, stepIdx) => (
            <li 
              key={step.label} 
              className={`relative ${stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20' : ''}`}
            >
              <div className="flex items-center">
                <div 
                  className={`relative flex h-8 w-8 items-center justify-center rounded-full 
                    ${step.number < currentStep 
                      ? 'bg-blue-600' 
                      : step.number === currentStep 
                        ? 'bg-blue-600 ring-2 ring-blue-200' 
                        : 'bg-gray-200'
                    }`}
                >
                  {step.number < currentStep ? (
                    <svg 
                      className="h-5 w-5 text-white" 
                      viewBox="0 0 20 20" 
                      fill="currentColor" 
                      aria-hidden="true"
                    >
                      <path 
                        fillRule="evenodd" 
                        d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" 
                        clipRule="evenodd" 
                      />
                    </svg>
                  ) : (
                    <span 
                      className={`text-sm font-medium ${
                        step.number === currentStep ? 'text-white' : 'text-gray-500'
                      }`}
                    >
                      {step.number}
                    </span>
                  )}
                </div>
                {stepIdx !== steps.length - 1 ? (
                  <div 
                    className={`absolute top-4 right-0 h-0.5 w-5/6 ${
                      stepIdx < currentStep - 1 ? 'bg-blue-600' : 'bg-gray-200'
                    }`}
                  />
                ) : null}
              </div>
              <div className="mt-2">
                <span className="text-sm font-medium text-gray-900">{step.label}</span>
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default OnboardingStepIndicator;
